import { NavLink, useNavigate } from "react-router-dom";
import UseTitle from "../../components/useTitle";
import "./CampaignFull.scss";

const CampaignFull = ({ campaign, setIsUpdate, setIsAddXP, setIsDelete }) => {
  // Définition du titre de la page
  UseTitle("Campagne " + (campaign?.name || ""));

  const navigate = useNavigate();

  return (
    <>
      <div className="campaign-full">
        <h1>{campaign.name}</h1>
        <p>
          <em>Description : {campaign.description || "Aucune"}</em>
        </p>
        <p>
          Personnages <strong>({campaign.characters.length})</strong>
        </p>
        {campaign.characters.map((character) => (
          <h2 key={character.id}>
            <NavLink key={character.id} to={`/character/${character.id}`}>
              {character.name} <small>({character.user_proprietary})</small>
            </NavLink>
          </h2>
        ))}
        <div className="buttons">
          <button className="bt" onClick={() => navigate(`/campaigns/`)}>
            Retour
          </button>
          {campaign.characters.length > 0 && (
            <>
              <button className="bt" onClick={() => setIsAddXP(true)}>
                Donner XP
              </button>
            </>
          )}
          <button className="bt" onClick={() => setIsUpdate(true)}>
            Modifier
          </button>
          <button className="bt" onClick={() => setIsDelete(true)}>
            Supprimer
          </button>
        </div>
      </div>
    </>
  );
};

export default CampaignFull;
